import React from 'react'
import { Skeleton } from 'antd'

import ItemWrapper from '../ItemWrapper'

import styles from './index.module.scss'

import type { AudioGlobalMetadata } from '@/hooks/audio/store'


import { cls } from 'tagged-classnames-free';
export type MusicMetadataInit = {
  status: 'init'
} & Pick<AudioGlobalMetadata, 'id'>

export type MusicMetadataProcessing = {
  status: 'processing'
} & Pick<AudioGlobalMetadata, 'id'>

export interface MusicItemLoadingProps {
  data: MusicMetadataInit | MusicMetadataProcessing
}

const MusicItemLoading: React.FC<MusicItemLoadingProps> = (props) => {
  return (
    <ItemWrapper className={cls`gap-6`}>
      <div
        className={cls`
          border-f-border-secondary flex size-[68px]
          items-center justify-center border border-b-0
          ${styles.bg}
        `}
      >
        <span
          className={cls`i-cus--tad-loading text-f-text size-5 animate-spin`}
        />
      </div>

      <Skeleton.Input block className='flex-1' active />
    </ItemWrapper>
  )
}

export default MusicItemLoading
